import cx from "classnames";
import * as React from "react";

interface QESWidgetProps {
  /**
   * Class names for custom styling
   */
  className?: string;
  "data-testid"?: string;
  /**
   * The size of the widget, either "default" or "small". This can be used to adjust padding.
   */
  size?: "default" | "small";
}

/**
 * A generic widget/card component wrapper that takes children to render.
 * Use the QESWidgetHeader, QESWidgetContent, and the QESWidgetFooter to build this out with predefined styling
 */
export const QESWidget: React.FC<React.PropsWithChildren<QESWidgetProps>> = ({
  children,
  className,
  "data-testid": dataTestId,
  size = "default",
}) => {
  return (
    <div className={cx("qes-widget", { "qes-widget--small": size === "small" }, className)} data-testid={dataTestId}>
      {children}
    </div>
  );
};
